module.exports = __webpack_public_path__ + "static/media/p4_img4.84aabc8e.svg";